// pages/HeaderLinksManager.jsx

import React, { useEffect, useState } from "react";
import axios from "axios";

export default function HeaderLinksManager() {
  const [parents, setParents] = useState([]);
  const [parentForm, setParentForm] = useState({ title: "", url: "", order: 0 });
  const [childForm, setChildForm] = useState({ title: "", url: "", order: 0, parentId: "" });

  const API = "https://api.solarstation.in/headerLink";

  const fetchLinks = async () => {
    const res = await axios.get(`${API}/getAll`);
    setParents(res.data);
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const handleAddParent = async (e) => {
    e.preventDefault();
    await axios.post(`${API}/addParent`, parentForm);
    setParentForm({ title: "", url: "", order: 0 });
    fetchLinks();
  };

  const handleAddChild = async (e) => {
    e.preventDefault();
    await axios.post(`${API}/${childForm.parentId}/child`, {
      title: childForm.title,
      url: childForm.url,
      order: childForm.order,
    });
    setChildForm({ title: "", url: "", order: 0, parentId: "" });
    fetchLinks();
  };

  const handleDeleteParent = async (id) => {
    await axios.delete(`${API}/deleteParent/${id}`);
    fetchLinks();
  };

const handleDeleteChild = async (parentId, childId) => {
  console.log("Deleting child", { parentId, childId }); // 🕵️ check values
  await axios.delete(`${API}/${parentId}/child/${childId}`);
  fetchLinks();
};

  // Recursive renderer for options
const renderOptions = (node, prefix = "") => {
  return (
    <React.Fragment key={node._id}>
      <option value={node._id}>
        {prefix}{node.title}
      </option>
      {node.children?.map((child) => renderOptions(child, prefix + " → "))}
    </React.Fragment>
  );
};



// Recursive renderer for displaying links
const renderTree = (node, parentId = null) => {
  return (
    <li key={node._id} className="mb-1">
      <div className="flex justify-between items-center">
        <span>
          {node.title} — {node.url} (Order: {node.order})
        </span>
        <button
          className="text-red-400 text-sm ml-2"
          onClick={() =>
            parentId
              ? handleDeleteChild(parentId, node._id) // ✅ ab correct parent-child pair milega
              : handleDeleteParent(node._id)
          }
        >
          Delete
        </button>
      </div>

      {node.children && node.children.length > 0 && (
        <ul className="ml-6 mt-1">
          {node.children.map((child) =>
            renderTree(child, node._id) // ✅ ab har child ke liye uske actual parent ka id milega
          )}
        </ul>
      )}
    </li>
  );
};





  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Header Links Manager</h2>

      {/* Add Parent Link */}
      <form onSubmit={handleAddParent} className="mb-6 border p-4 rounded bg-gray-100">
        <h3 className="font-semibold text-lg mb-2">Add Parent Link</h3>
        <input type="text" placeholder="Title" className="input" value={parentForm.title} onChange={(e) => setParentForm({ ...parentForm, title: e.target.value })} />
        <input type="text" placeholder="URL" className="input" value={parentForm.url} onChange={(e) => setParentForm({ ...parentForm, url: e.target.value })} />
        <input type="number" placeholder="Order" className="input" value={parentForm.order} onChange={(e) => setParentForm({ ...parentForm, order: Number(e.target.value) })} />
        <button type="submit" className="btn">Add Parent</button>
      </form>

      {/* Add Child Link */}
      <form onSubmit={handleAddChild} className="mb-6 border p-4 rounded bg-gray-100">
  <h3 className="font-semibold text-lg mb-2">Add Child Link</h3>

    

  <select
  className="input"
  value={childForm.parentId}
  onChange={(e) => setChildForm({ ...childForm, parentId: e.target.value })}
>
  <option value="">Select Parent/Child</option>
  {parents.map((parent) => renderOptions(parent))}
</select>

  <input
    type="text"
    placeholder="Title"
    className="input"
    value={childForm.title}
    onChange={(e) => setChildForm({ ...childForm, title: e.target.value })}
  />
  <input
    type="text"
    placeholder="URL"
    className="input"
    value={childForm.url}
    onChange={(e) => setChildForm({ ...childForm, url: e.target.value })}
  />
  <input
    type="number"
    placeholder="Order"
    className="input"
    value={childForm.order}
    onChange={(e) =>
      setChildForm({ ...childForm, order: Number(e.target.value) })
    }
  />
  <button type="submit" className="btn">
    Add Child
  </button>
</form>

     {/* Display Header Links */}
<div className="mt-8">
  <h3 className="text-2xl font-bold mb-4 text-gray-800">Existing Header Links</h3>

  <div className="space-y-4">
    {parents.map((parent) => (
      <div
        key={parent._id}
        className="border rounded-lg p-4 shadow-sm bg-white"
      >
        {/* Parent block */}
        <div className="flex justify-between items-center border-b pb-2 mb-3">
          <div>
            <p className="font-semibold text-lg text-gray-900">{parent.title}</p>
            <p className="text-sm text-gray-600">{parent.url}</p>
            <span className="text-xs text-gray-500">Order: {parent.order}</span>
          </div>
          <button
            className="text-red-500 hover:text-red-700 text-sm font-medium"
            onClick={() => handleDeleteParent(parent._id)}
          >
            Delete
          </button>
        </div>

        {/* Children */}
        {parent.children && parent.children.length > 0 ? (
          <ul className="space-y-2 ml-4">
            {parent.children.map((child) => renderTree(child, parent._id))}
          </ul>
        ) : (
          <p className="text-gray-400 text-sm italic">No child links</p>
        )}
      </div>
    ))}
  </div>
</div>



      {/* Basic styles */}
      <style jsx>{`
        .input {
          display: block;
          width: 100%;
          margin-bottom: 10px;
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 6px;
        }
        .btn {
          padding: 8px 12px;
          background-color: #2563eb;
          color: white;
          border-radius: 6px;
          margin-top: 4px;
        }
      `}</style>
    </div>
  );
}
